import { Lightbulb } from "lucide-react";

/** "What the AI did", from the prototype. Plain language, no internal vocabulary. */
export function Explainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="explainer">
      <Lightbulb />
      <div>
        <div className="h">What the system did</div>
        <p>{children}</p>
      </div>
    </div>
  );
}
